import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { PeriodVertex } from '../interfaces/vertices/periods';

export default (
  periods: Types.Mixed.Period[],
  options: BaseOptions
): OutTypes.period[] => {
  return periods
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<PeriodVertex> = {
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<PeriodVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
